export const Variant = {
  DANGER: 'danger',
  OUTLINED: 'outlined',
  PRIMARY: 'primary' /** default */,
  PRIMARY_TRANSPARENT: 'primary-transparent',
  SECONDARY: 'secondary',
  SECONDARY_TRANSPARENT: 'secondary-transparent',
  UNDERLINED: 'underlined',
};

export const Type = {
  BUTTON: 'button' /** default */,
  RESET: 'reset',
  SUBMIT: 'submit',
};

export const Size = {
  LARGE: 'large',
  MEDIUM: 'medium' /** default */,
  SMALL: 'small',
};

export const IconPosition = {
  LEFT: 'left' /** default */,
  RIGHT: 'right',
};
